import { InputCommerceAttribute } from 'utils/api/models/numbers/usage';
import { SinglePackage } from 'utils/api/models/numbers/singlePackage';
import { translate } from 'components/Translation';
import { InputUsageCharacteristic } from 'utils/api/models/ecommerce/usageOperation';

export const CustomAttribute = {
	HIERARCHY_INDEX: 'HIERARCHY_INDEX',
	CONTRACT_DURATION: 'CONTRACT_DURATION',
	FBB_PRO: 'FBB_PRO',
	HBB_DOWN_SPEED: 'HBB_DOWN_SPEED',
	HBB_UP_SPEED: 'HBB_UP_SPEED',
	HBB_MAIL_INC: 'HBB_MAIL_INC',
	MBB_PACKAGE_SIZE: 'MBB_PACKAGE_SIZE',
	MBB_PACKAGE_SIZE_GOBIZ: 'MBB_PACKAGE_SIZE_GOBIZ',
	USE_ITEM_DESC: 'USE_ITEM_DESC',
	RENEWAL: 'RENEWAL',
	ROAMING_TYPE: 'ROAMING_TYPE',
	DURATION: 'DURATION',
	INCLUDED_ROAMING_DATA: 'INCLUDED_ROAMING_DATA',
	INCLUDED_MINUTES: 'INCLUDED_MINUTES',
	LOC_MIN_COST: 'LOC_MIN_COST',
	LOC_DATA_PACKAGE_SIZE: 'LOC_DATA_PACKAGE_SIZE',
	LOC_EXTRA_DATA_PACKAGE_SIZE: 'LOC_EXTRA_DATA_PACKAGE_SIZE',
	LOC_MIN_PACKAGE_SIZE: 'LOC_MIN_PACKAGE_SIZE',
	AL_UFUQ: 'AL_UFUQ',
	BACKGROUND_URL: 'BACKGROUND_URL',
	BAQAT_PLUS: 'BAQAT_PLUS',
	ACT_THIS_ON_RENEW: 'ACT_THIS_ON_RENEW',
	CONTRACT_TO_ACTIVATE: 'CONTRACT_TO_ACTIVATE',
	VAT_VALUE: 'VAT_VALUE',
	CONVERGENT_ELIGIBLE: 'CONVERGENT_ELIGIBLE',
	DEFINITION_SOURCE: 'DEFINITION_SOURCE',
	PRODUCT_DESCRIPTION: 'PRODUCT_DESCRIPTION',
	DESTINATION: 'DESTINATION',
	DOUBLE_DATA_INCLUDED: 'DOUBLE_DATA_INCLUDED',
	DURATION_CATEGORY: 'DURATION_CATEGORY',
	PACKAGE_VALIDITY: 'PACKAGE_VALIDITY',
	IS_EXTENDED_BY: 'IS_EXTENDED_BY',
	IS_EXTENDED_BY_LABEL: 'IS_EXTENDED_BY_LABEL',
	FIND_OUT_MORE_LINK: 'FIND_OUT_MORE_LINK',
	GROUP_ID: 'GROUP_ID',
	HAYYAK_PLUS: 'HAYYAK_PLUS',
	HAYYAK_UPSELL: 'HAYYAK_UPSELL',
	ICON_ADD: 'ICON_ADD',
	ICON_MAIN: 'ICON_MAIN',
	INCLUDED_DATA: 'INCLUDED_DATA',
	HYBRID_OFFER: 'HYBRID_OFFER',
	MULTI_ACTIVATE: 'MULTI_ACTIVATE',
	LOC_EXTRA_PACKAGE_LABEL: 'LOC_EXTRA_PACKAGE_LABEL',
	OFFER: 'Offer',
	PLAN_TYPE: 'PLAN_TYPE',
	PLAN_RELATED: 'PLAN_RELATED',
	SUBSCRIPTION_RATE: 'SUBSCRIPTION_RATE',
	PROMO_PRODUCT_ID: 'PROMO_PRODUCT_ID',
	PROMO_VOUCHER_ID: 'PROMO_VOUCHER_ID',
	PROMO_VOUCHER_VALUE: 'PROMO_VOUCHER_VALUE',
	REQ_PROD: 'REQ_PROD',
	SELF_ACTIVATE: 'SELF_ACTIVATE',
	SELF_DEACTIVATE: 'SELF_DEACTIVATE',
	TOOLBAR_SHORT_DESC: 'TOOLBAR_SHORT_DESC',
	UNL_NUM_COUNT: 'UNL_NUM_COUNT',
	TAG: 'TAG',
	WHATSAPP_PACKAGE_SIZE: 'WHATSAPP_PACKAGE_SIZE',
	INSTALLATION_FEE: 'INSTALLATION_FEE',
	MONTHLY_FEE: 'MONTHLY_FEE',
	EBU_CONFIG_PRODUCT: 'EBU_CONFIG_PRODUCT',
	LOC_DATA_COST: 'LOC_DATA_COST',
	LOC_SMS_COST: 'LOC_SMS_COST',
	LOC_MMS_COST: 'LOC_MMS_COST',
	DEFAULT_PAYG: 'DEFAULT_PAYG',
	DEFAULT_ROAMING_PAYG: 'DEFAULT_ROAMING_PAYG',
	PLAN_TARIFF_ID: 'PLAN_TARIFF_ID',
	PROVISIONING_ID: 'PROVISIONING_ID',
	STATIC_IP: 'STATIC_IP',
	CALL_PRICE_PEAK: 'CALL_PRICE_PEAK',
	CALL_PRICE_OFF_PEAK: 'CALL_PRICE_OFF_PEAK',
	PRODUCT_TYPE: 'PRODUCT_TYPE',
	INCLUDED_SMS: 'INCLUDED_SMS',
	LOC_SMS_PACKAGE_SIZE: 'LOC_SMS_PACKAGE_SIZE',
	INCLUDED_ROAM_REC_MIN: 'INCLUDED_ROAM_REC_MIN',
	INT_CALL_DISCOUNT_SIZE: 'INT_CALL_DISCOUNT_SIZE',
	PROMO_DATA: 'PROMO_DATA',
	PROMO_DATA_NAT_PLUS_GCC: 'PROMO_DATA_NAT_PLUS_GCC',
	PROMO_MINUTES: 'PROMO_MINUTES',
	PROMO_APPSTORE_CREDIT: 'PROMO_APPSTORE_CREDIT',
	PROMO_GOBIZ_DATA: 'PROMO_GOBIZ_DATA',
	PROMO_ROAM_REC_MIN: 'PROMO_ROAM_REC_MIN',
	INCLUDED_DATA_LABEL: 'INCLUDED_DATA_LABEL',
	INCLUDED_MINUTES_LABEL: 'INCLUDED_MINUTES_LABEL',
	WHATSAPP_PACKAGE_SIZE_LABEL: 'WHATSAPP_PACKAGE_SIZE_LABEL',
	DOUBLE_DATA_INCLUDED_LABEL: 'DOUBLE_DATA_INCLUDED_LABEL',
	LOC_SMS_PACKAGE_SIZE_LABEL: 'LOC_SMS_PACKAGE_SIZE_LABEL',
	INCLUDED_ROAMING_DATA_LABEL: 'INCLUDED_ROAMING_DATA_LABEL',
	INCLUDED_ROAM_REC_MIN_LABEL: 'INCLUDED_ROAM_REC_MIN_LABEL',
	INT_CALL_DISCOUNT_SIZE_LABEL: 'INT_CALL_DISCOUNT_SIZE_LABEL',
	PROMO_DATA_LABEL: 'PROMO_DATA_LABEL',
	PROMO_DATA_NAT_PLUS_LABEL: 'PROMO_DATA_NAT_PLUS_LABEL',
	PROMO_MINUTES_LABEL: 'PROMO_MINUTES_LABEL',
	PROMO_APPSTORE_CREDIT_LABEL: 'PROMO_APPSTORE_CREDIT_LABEL',
	PROMO_GOBIZ_DATA_LABEL: 'PROMO_GOBIZ_DATA_LABEL',
	PROMO_ROAM_REC_MIN_LABEL: 'PROMO_ROAM_REC_MIN_LABEL',
	GOBIZ_SMS_COUNT: 'GOBIZ_SMS_COUNT',
	GOBIZ_UNIFIED_ROAMING: 'GOBIZ_UNIFIED_ROAMING',
	GOBIZ_CALLS_MIN: 'GOBIZ_CALLS_MIN',
	MBB_SIZE_GLOBAL: 'MBB_SIZE_GLOBAL',
	EXC_PROD: 'EXC_PROD',
	TRY_AND_BUY: 'TRY_AND_BUY',

	SHORT_DESCRIPTION: 'shortDescription',
	THUMBNAIL: 'thumbnail',
	FULL_IMAGE: 'fullImage',
	LONG_DESCRIPTION: 'longDescription',
	CPN_MINUTES: 'CPN Minutes',
	NATIONAL_MINUTES: 'National Minutes',
	SMS: 'SMS',
	LOCAL_AND_GCC_DATA: 'Local and GCC Data',
	INTERNATIONAL_CALL: 'International Call',
	GOBIZ_DATA: 'GoBiz Data',
	GOBIZ_MINUTES: 'GoBiz Minutes',
	DATA_GLOBAL: 'Data - Global',
	IP_CONFIG: 'IP_CONFIG',
	IP_MODE: 'IP_MODE',
	MAIN_STATIC_IP_CONFIG: 'MAIN_STATIC_IP_CONFIG',
	DEFAULT_CONFIG: 'DEFAULT_CONFIG',
	WFBB: 'WFBB',
	WEB_PLAN_INFO: 'WEB_PLAN_INFO',
	ORDER_SUMMARY_FEATURED: 'ORDER_SUMMARY_FEATURED',
};

export const getExtractedValue = (inputString: string): string | number => {
	if (typeof inputString === 'string') {
		const value = inputString.replace(/[A-z]/g, '').trim();
		return value ? parseFloat(value) || value : '-';
	} else {
		return '-';
	}
};

export const getExtractedUnit = (input: string, defaultValue = '-'): string => {
	if (typeof input === 'string') {
		const unit = input.replace(/[0-9]/g, '').trim();
		return unit ? unit : defaultValue;
	} else {
		return defaultValue;
	}
};

export const extractPrice = (
	item: types.ecommerce.CatalogEntryView,
	usage: 'Offer' | 'Display' = 'Display',
	defaultPrice?: string,
	defaultCurrency?: string
) => {
	const defaultFinalPrice = {
		currency: defaultCurrency || 'OMR',
		price: defaultPrice,
	};

	const attributes = item.attributes || [];

	for (const singleAttribute of attributes) {
		if (!!singleAttribute && singleAttribute.identifier === 'price') {
			item = { price: singleAttribute.values as any } as any;
			break;
		}
	}

	if (item && item.price) {
		let orginalPrice = '';
		item.price.forEach((singlePrice: { usage: string; value: string }) => {
			if (
				// try get price with 'Display' usage
				(singlePrice.usage && singlePrice.usage === usage && singlePrice.value) ||
				// if none, try get any value
				(orginalPrice === '' && singlePrice.value)
			) {
				orginalPrice = singlePrice.value;
			}
		});

		const splittedPrice = orginalPrice.split('.');
		const price = splittedPrice[1] !== '0' ? orginalPrice : splittedPrice[0];
		const currency = item.price[0] && item.price[0].currency ? item.price[0].currency : 'OMR';

		const finalPrice = {
			currency,
			price: parseFloat(price) || price,
		};

		if (price && currency) {
			return finalPrice;
		} else {
			return defaultFinalPrice;
		}
	} else {
		return defaultFinalPrice;
	}
};

export const parsers = {
	boolean: (input: any) => [true, 'TRUE', 'true', 1, '1'].includes(input),
	duration: (input: any) => {
		let _input = input;
		if (String(input).startsWith('7')) {
			_input = 'Weekly';
		}
		if (String(input).startsWith('30')) {
			_input = 'Monthly';
		}
		switch (_input) {
			case 'Daily':
			case '1':
				return 1;
			case '2':
				return 2;
			case '3':
				return 3;
			case 'Weekly':
			case '7':
				return 7;
			case 'Monthly':
			case '30':
				return 30;
			case 'Special':
				return -1;
			default:
				return undefined;
		}
	},
	perioidName: (shortcut: string) => {
		switch (shortcut) {
			case 'MON':
				return 'Month';
			case 'WEE':
				return 'Week';
			default:
				return '';
		}
	},
};

export const convertGetUsageItemsToEcommerce = (items: InputCommerceAttribute[]) => {
	const output = {
		attributes: [],
	};
	items.forEach((item) => {
		output.attributes.push({
			identifier: item.name as never,
			values: item.values as never,
		} as never);
	});
	return output;
};

export const extractAttributeValue = (
	item: any,
	attributeName: string | string[],
	defaultOnNotFound: any = undefined
): any => {
	let value = defaultOnNotFound;
	const { attributes } = item;

	function findAttributeValue(attributeName: string) {
		for (const singleAttribute of attributes) {
			if (!!singleAttribute && singleAttribute.identifier === attributeName) {
				value = singleAttribute.values[0].value;
				break;
			}
		}
	}

	if (item && item.attributes && attributeName) {
		if (Array.isArray(attributeName)) {
			attributeName.forEach((attributeName) => {
				findAttributeValue(attributeName);
			});
		} else {
			findAttributeValue(attributeName);
		}
	} else {
		value = false;
	}
	return value;
};

export const extractAttributeUnitOfMeasure = (item: any, attributeName: string | string[]): any => {
	let unitOfMeasure;
	const { attributes } = item;

	function findAttributeValue(attributeName: string) {
		for (const singleAttribute of attributes) {
			if (!!singleAttribute && singleAttribute.identifier === attributeName) {
				unitOfMeasure = singleAttribute.values[0].unitOfMeasure;
				break;
			}
		}
	}

	if (item && item.attributes && attributeName) {
		if (Array.isArray(attributeName)) {
			attributeName.forEach((attributeName) => {
				findAttributeValue(attributeName);
			});
		} else {
			findAttributeValue(attributeName);
		}
	} else {
		unitOfMeasure = null;
	}
	return unitOfMeasure;
};

export const extractAttributeValuesAll = (item: any, attributeName: string) => {
	const allValues: any[] = [];
	if (item && item.attributes && attributeName) {
		item.attributes.forEach((singleAttribute: any) => {
			if (!!singleAttribute && singleAttribute.identifier === attributeName) {
				singleAttribute.values.forEach((singleValue: any) => {
					allValues.push(singleValue.value);
				});
			}
		});
		return allValues;
	} else {
		return [];
	}
};

export const extractPlanDetails = (singlePackage: SinglePackage) => {
	let arrayOfValues: any[] = [];

	const data =
		extractAttributeValue(singlePackage, CustomAttribute.LOC_DATA_PACKAGE_SIZE) ||
		extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_DATA);
	const minutes =
		extractAttributeValue(singlePackage, CustomAttribute.LOC_MIN_PACKAGE_SIZE) ||
		extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_MINUTES);
	const includedSms =
		extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_SMS) ||
		extractAttributeValue(singlePackage, CustomAttribute.LOC_SMS_PACKAGE_SIZE);
	const whatsapp = extractAttributeValue(singlePackage, CustomAttribute.WHATSAPP_PACKAGE_SIZE);
	const doubleData = extractAttributeValue(singlePackage, CustomAttribute.DOUBLE_DATA_INCLUDED);

	const includedRoamingData = extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_ROAMING_DATA);
	const includedRoamRecMin = extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_ROAM_REC_MIN);
	const intCallDiscount = extractAttributeValue(singlePackage, CustomAttribute.INT_CALL_DISCOUNT_SIZE);

	const promoData = extractAttributeValue(singlePackage, CustomAttribute.PROMO_DATA);
	const promoDataNatPlusGcc = extractAttributeValue(singlePackage, CustomAttribute.PROMO_DATA_NAT_PLUS_GCC);
	const promoMinutes = extractAttributeValue(singlePackage, CustomAttribute.PROMO_MINUTES);
	const promoAppStoreCredit = extractAttributeValue(singlePackage, CustomAttribute.PROMO_APPSTORE_CREDIT);
	const promoGoBizData = extractAttributeValue(singlePackage, CustomAttribute.PROMO_GOBIZ_DATA);
	const promoRoamRecMinutes = extractAttributeValue(singlePackage, CustomAttribute.PROMO_ROAM_REC_MIN);

	if (data) {
		const dataMeasureUnit =
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.LOC_DATA_PACKAGE_SIZE) ||
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.INCLUDED_DATA);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_DATA_LABEL),
			itemUnit: data.split(' ')[1],
			itemValue: data.split(' ')[0],
			period: parsers.perioidName(dataMeasureUnit),
			title: translate('package-name.data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (minutes) {
		const minutesMeasureUnit =
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.LOC_MIN_PACKAGE_SIZE) ||
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.INCLUDED_MINUTES);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_MINUTES_LABEL),
			itemUnit: '',
			itemValue: minutes,
			period: parsers.perioidName(minutesMeasureUnit),
			title: translate('package-name.minutes'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (whatsapp) {
		const whatsappMeasureUnit = extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.WHATSAPP_PACKAGE_SIZE);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.WHATSAPP_PACKAGE_SIZE_LABEL),
			itemUnit: whatsapp.split(' ')[1],
			itemValue: whatsapp.split(' ')[0],
			period: parsers.perioidName(whatsappMeasureUnit),
			title: translate('package-name.whatsapp'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (doubleData) {
		const doubleDataMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.DOUBLE_DATA_INCLUDED
		);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.DOUBLE_DATA_INCLUDED_LABEL),
			itemUnit: doubleData.split(' ')[1],
			itemValue: doubleData.split(' ')[0],
			period: parsers.perioidName(doubleDataMeasureUnit),
			title: translate('package-name.double-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (includedSms) {
		const includedSmsMeasureUnit =
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.INCLUDED_SMS) ||
			extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.LOC_SMS_PACKAGE_SIZE);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.LOC_SMS_PACKAGE_SIZE_LABEL),
			itemUnit: includedSms.split(' ')[1],
			itemValue: includedSms.split(' ')[0],
			period: parsers.perioidName(includedSmsMeasureUnit),
			title: translate('package-name.sms'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (includedRoamingData) {
		const roamingDataMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.INCLUDED_ROAMING_DATA
		);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_ROAMING_DATA_LABEL),
			itemUnit: includedRoamingData.split(' ')[1],
			itemValue: includedRoamingData.split(' ')[0],
			period: parsers.perioidName(roamingDataMeasureUnit),
			title: translate('package-name.roaming-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (includedRoamRecMin) {
		const roamRecMinMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.INCLUDED_ROAM_REC_MIN
		);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.INCLUDED_ROAM_REC_MIN_LABEL),
			itemUnit: includedRoamRecMin.split(' ')[1],
			itemValue: includedRoamRecMin.split(' ')[0],
			period: parsers.perioidName(roamRecMinMeasureUnit),
			title: translate('package-name.roaming-receiving-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (intCallDiscount) {
		const callDiscountMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.INT_CALL_DISCOUNT_SIZE
		);
		const tempObj = {
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.INT_CALL_DISCOUNT_SIZE_LABEL),
			itemUnit: intCallDiscount.split(' ')[1],
			itemValue: intCallDiscount.split(' ')[0],
			period: parsers.perioidName(callDiscountMeasureUnit),
			title: translate('package-name.discount-on-intl-calls'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoData) {
		const promoDataMeasureUnit = extractAttributeUnitOfMeasure(singlePackage, CustomAttribute.PROMO_DATA);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_DATA_LABEL),
			itemUnit: promoData.split(' ')[1],
			itemValue: promoData.split(' ')[0],
			period: parsers.perioidName(promoDataMeasureUnit),
			title: translate('package-name.extra-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoDataNatPlusGcc) {
		const promoDataNatPlusGccMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.PROMO_DATA_NAT_PLUS_GCC
		);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_DATA_NAT_PLUS_LABEL),
			itemUnit: promoDataNatPlusGcc.split(' ')[1],
			itemValue: promoDataNatPlusGcc.split(' ')[0],
			period: parsers.perioidName(promoDataNatPlusGccMeasureUnit),
			title: translate('package-name.data-nat-plus'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoMinutes) {
		const promoDataNatPlusGccMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.PROMO_MINUTES
		);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_MINUTES_LABEL),
			itemUnit: promoMinutes.split(' ')[1],
			itemValue: promoMinutes.split(' ')[0],
			period: parsers.perioidName(promoDataNatPlusGccMeasureUnit),
			title: translate('package-name.extra-minutes'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoAppStoreCredit) {
		const promoDataNatPlusGccMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.PROMO_APPSTORE_CREDIT
		);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_APPSTORE_CREDIT_LABEL),
			itemUnit: promoAppStoreCredit.split(' ')[1],
			itemValue: promoAppStoreCredit.split(' ')[0],
			period: parsers.perioidName(promoDataNatPlusGccMeasureUnit),
			title: translate('package-name.appstore-credit'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoGoBizData) {
		const promoDataNatPlusGccMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.PROMO_GOBIZ_DATA
		);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_GOBIZ_DATA_LABEL),
			itemUnit: promoGoBizData.split(' ')[1],
			itemValue: promoGoBizData.split(' ')[0],
			period: parsers.perioidName(promoDataNatPlusGccMeasureUnit),
			title: translate('package-name.gobiz-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (promoRoamRecMinutes) {
		const promoDataNatPlusGccMeasureUnit = extractAttributeUnitOfMeasure(
			singlePackage,
			CustomAttribute.PROMO_ROAM_REC_MIN
		);
		const tempObj = {
			isBenefit: true,
			itemLabel: extractAttributeValue(singlePackage, CustomAttribute.PROMO_ROAM_REC_MIN_LABEL),
			itemUnit: promoRoamRecMinutes.split(' ')[1],
			itemValue: promoRoamRecMinutes.split(' ')[0],
			period: parsers.perioidName(promoDataNatPlusGccMeasureUnit),
			title: translate('package-name.extra-rec-minutes'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}

	return arrayOfValues;
};

export const extractPayGDetails = (singlePackage: SinglePackage) => {
	let arrayOfValues: any[] = [];

	const data = extractAttributeValue(singlePackage, CustomAttribute.LOC_DATA_COST);
	const minutes = extractAttributeValue(singlePackage, CustomAttribute.LOC_MIN_COST);
	const sms = extractAttributeValue(singlePackage, CustomAttribute.LOC_SMS_COST);
	const mms = extractAttributeValue(singlePackage, CustomAttribute.LOC_MMS_COST);
	if (data) {
		const tempObj = {
			itemUnit: data.split(' ')[1],
			itemValue: data.split(' ')[0],
			title: translate('package-name.national-data'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (minutes) {
		const tempObj = {
			itemUnit: minutes.split(' ')[1],
			itemValue: minutes.split(' ')[0],
			title: translate('package-name.national-minutes'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (sms) {
		const tempObj = {
			itemUnit: sms.split(' ')[1],
			itemValue: sms.split(' ')[0],
			title: translate('package-name.national-sms'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	if (mms) {
		const tempObj = {
			itemUnit: mms.split(' ')[1],
			itemValue: mms.split(' ')[0],
			title: translate('package-name.national-mms'),
		};
		arrayOfValues = [...arrayOfValues, tempObj];
	}
	return arrayOfValues;
};

export const extractItemValue = (item: InputUsageCharacteristic[], itemName: string) => {
	if (!!item && itemName) {
		const _item = item.find((item) => item.name === itemName);
		if (!!_item?.value) {
			return _item.value;
		}
	}
	return '';
};
